import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import GameLevel from '../UI/GameLevel';
import LevelBackground from './LevelBackground';
import LevelData from './LevelData';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class GameArea extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.scoreNum = 0;
    this.scoreTxt = ABCyaPhaser.Text.addText(0, 0, 24, '0xFFFFFF', FontKeys._odin_roundedregular, `SCORE: ${this.scoreNum}`, this, true);
    this.scoreTxt.y = this.scoreTxt.height;

    this.targetTxt = ABCyaPhaser.Text.addText(0, 0, 24, '0xFFFFFF', FontKeys._odin_roundedregular, `TARGET NUMBER: ${gameData.addNum}`, this, true);
    this.targetTxt.y = this.scoreTxt.y + this.targetTxt.height + 10;

    this.bottomBorder = ABCyaPhaser.Images.addImage(0, 0, 'leaf-1', this).setOrigin(0, 0);
    this.bottomBorder.y = this.targetTxt.y + 10;
  }

  setUpArea(levelNum) {
    if (this.levelBg) {
      this.levelBg.destroy();
      this.levelBg = null;
    }
    this.levelBg = new LevelBackground(this.scene, this);
    this.add(this.levelBg);

    this.curLevelData = LevelData[`level-${levelNum.toString()}`];
    this.currentLevel = new GameLevel(this.scene, this.curLevelData);
    this.add(this.currentLevel);

    this.currentLevel.once('LEVEL_END', (e) => {this.handleLevelEnd(e);});

    this.levelBg.setUpBackground(this.curLevelData.bgColor,this.curLevelData.corners);

    this.layoutGame();
    this.startLevel();
  };

  startLevel() {
    this.levelRunning = true;
    this.currentLevel.setUpLevel();
  };

  toggleLevelReady(ready) {
    this.currentLevel.isReady = ready;
  };

  handleLevelEnd(e) {
    this.levelRunning = false;
    if (e) {
      this.showLevelCleared();
    }
    else {
      this.emit('GAME_STAGE_END', false);
    }
  };

  showLevelCleared() {
    this.currentLevel.once('BONUS_COMPLETE', () => {this.handleBonusComplete();});

    this.currentLevel.showBonus();
  };

  handleBonusComplete() {
    this.bonusBox = this.scene.add.container();

    const bg = ABCyaPhaser.Images.addImage(0, 0, 'popup-bg', this.bonusBox).setOrigin(.5, .5);
    bg.scaleX = 0.7;

    const congrats = ABCyaPhaser.Text.addText(0, 0, 45, '0x333333', FontKeys._odin_roundedregular, 'Dinoriffic!', this.bonusBox, true);

    const score = ABCyaPhaser.Text.addText(0, 0, 35, '0x333333', FontKeys._odin_roundedregular, `Score: ${gameData.score.toString()}`, this.bonusBox, true);

    const next = ABCyaPhaser.Text.addText(0, 0, 30, '0x333333', FontKeys._odin_roundedregular, 'Next Level', this.bonusBox, true);

    const go = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'btnStart', null, () => {
      go.setEnabled(false);
      this.toNext();
    }, this.bonusBox, { disabledTint: '0xFFFFFF' }).setEnabled(false);

    congrats.y = -bg.getBounds().height / 2 + 60;
    score.y = congrats.y + congrats.getBounds().height + 10;

    next.y = score.y + score.getBounds().height + 10;

    next.scaleX = 0;
    next.scaleY = 0;
    next.alpha = 0;
    go.y = next.y + next.getBounds().height + (go.getBounds().height / 2) + 30;

    go.scaleX = 0;
    go.scaleY = 0;
    go.alpha = 0;

    this.bonusBox.scoreTxt = score;
    this.bonusBox.goBtn = go;
    this.bonusBox.nextTxt = next;
    this.bonusBox.x = this.scene.mid.x;
    this.bonusBox.y = this.scene.mid.y;
    this.bonusBox.scaleX = 0;
    this.bonusBox.scaleY = 0;
    this.bonusBox.alpha = 0;

    this.add(this.bonusBox);

    ABCyaPhaser.Tweens.addTween(this.bonusBox, 500, { alpha: 1,scaleX: 1,scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);

    if (gameData.level !== 3) {
      ABCyaPhaser.Tweens.addTween(this.bonusBox.nextTxt, 300, { delay: 1000, alpha: 1,scaleX: 1,scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.playBtnSound('swish');
      });
      ABCyaPhaser.Tweens.addTween(this.bonusBox.goBtn, 300, { delay: 1500, alpha: 1,scaleX: 1,scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.bonusBox.goBtn.setEnabled(true);
        this.playBtnSound('swish');
      });

      this.scene.time.delayedCall(2000, () => {this.playBtnSound('dinoriffic');});
    }
    else {
      this.scene.time.delayedCall(2000, () => {this.toNext();});

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._powerup, this.scene);
    }
  };

  playBtnSound(soundName) {
    const name = soundName === 'swish' ? SoundAssetKeys._swish : LocalizationSoundAssetKeys._dinoriffic;
    const audioAtlas = soundName === 'swish' ? ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE : ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE;
    ABCyaPhaser.Audio.playOneShot(name, this.scene, 1, false, 0, audioAtlas);
  };

  toNext() {
    // remove bonus box
    this.currentLevel.cleanUp();
    this.currentLevel = null;
    this.curLevelData = null;

    if (gameData.level < 3) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      gameData.level++;
      ABCyaPhaser.Tweens.addTween(this.bonusBox, 400, { alpha: 0,scaleX: 0,scaleY: 0 }, Phaser.Math.Easing.Quadratic.In, () => {
        this.setUpArea(gameData.level);
      });
    }
    else {
      // end game
      this.emit('GAME_STAGE_END', true);
    }
  };

  updateGame() {
    if (this.currentLevel) this.currentLevel.updateLevel();
    if (this.bonusBox) {
      this.bonusBox.scoreTxt.text = gameData.score.toString();
    }
  };

  layoutGame() {
    // scale game area
    if (this.levelBg) this.levelBg.layoutBackground();
    if (this.currentLevel) {
      this.currentLevel.scaleX = 1;
      this.currentLevel.scaleY = this.currentLevel.scaleX;

      if (this.curLevelData.vAlign === 'top') {
        this.currentLevel.y = 0;
      }
      else if (this.curLevelData.vAlign === 'mid') {
        this.currentLevel.y = this.scene.mid.y - (this.currentLevel.getBounds().height / 2) * this.currentLevel.scaleY;
      }
      else {
        this.currentLevel.y = this.scene.mid.y * 2 - this.currentLevel.getBounds().height;
      }

      if (this.curLevelData.hAlign === 'left') {
        this.currentLevel.x = 0;
      }
      else if (this.curLevelData.hAlign === 'mid') {
        this.currentLevel.x = this.scene.mid.x - (this.currentLevel.getBounds().width / 2) * this.currentLevel.scaleX;
      }
      else {
        this.currentLevel.x = this.scene.mid.x * 2 - this.currentLevel.getBounds().width * this.currentLevel.scaleX;
      }
    }

    if (this.bonusBox) {
      this.bonusBox.x = this.scene.mid.x;
      this.bonusBox.y = this.scene.mid.y;
    }
  };

  cleanUp() {
    // this.removeAll(true);
  };
}